import(/* webpackMode: "eager" */ "/var/www/rutavix/frontend/src/app/[locale]/acerca/page.tsx");
